<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h3>{{ $t('queue.create') }}</h3>
    </div>
    <div class="modal-content">
      <form
        id="form-create-queue"
        action=""
      >
        <div class="input-group">
          <div
            :class="{ 'field-error': namePt === '' }"
            class="input input-text"
          >
            <label for="create-queue-name-pt">{{ $t('name') }}</label>
            <input
              id="create-queue-name-pt"
              v-model="namePt"
              type="text"
              :placeholder="$t('insert.queue.name')"
              required
            >
          </div>
          <span
            v-show="namePt === ''"
            class="error-message"
          >
            {{ $t('mandatory.field') }}
          </span>
        </div>

        <div class="input-group">
          <div
            :class="{ 'field-error': nameEn === '' }"
            class="input input-text"
          >
            <label for="queue-name-en">{{ $t('name') }} - {{ $t('english') }}</label>
            <input
              id="queue-name-en"
              v-model="nameEn"
              type="text"
              :placeholder="$t('translate.queue.name')"
              required
            >
            <span
              v-show="nameEn === ''"
              class="error-message"
            >
              {{ $t('mandatory.field') }}
            </span>
          </div>
        </div>

        <div class="input-group">
          <div
            :class="{ 'field-error': queueLetter === null }"
            class="input input-select"
          >
            <label for="edit-queue-letter">{{ $t('letter') }}</label>
            <div class="btn-select">
              <select
                id="edit-queue-letter"
                v-model="queueLetter"
              >
                <option
                  v-for="letter in alphabet"
                  v-show="!service.queues.hasOwnProperty(letter.toLowerCase())"
                  :key="letter"
                  :value="letter"
                >
                  {{ letter }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn-secondary"
            @click="close"
          >
            {{ $t('cancel') }}
          </button>
          <button
            type="button"
            class="btn-primary btn-active main-action"
            @click="createQueue()"
          >
            {{ $t('create') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import api from '@/api'

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    serviceID: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      open: false,
      alphabet: [],
      namePt: undefined,
      nameEn: undefined,
      queueLetter: null
    }
  },
  computed: {
    ...mapState(['service', 'currentTickets'])
  },
  async mounted () {
    setTimeout(() => {
      this.open = true
    }, 100)
    this.alphabet = this.genCharArray('A', 'Z')
  },
  methods: {
    async close () {
      this.$emit('input', false)
    },
    ...mapActions(['fetchService', 'fetchCurrentTickets']),

    genCharArray (charA, charZ) {
      let a = []
      let i = charA.charCodeAt(0)
      let j = charZ.charCodeAt(0)
      for (; i <= j; ++i) {
        a.push(String.fromCharCode(i))
      }
      return a
    },
    async createQueue () {
      await api.createQueue(
        this.serviceID,
        this.queueLetter,
        this.namePt,
        this.nameEn
      )
      await this.fetchCurrentTickets(this.serviceID)
      await this.fetchService(this.serviceID)
      this.close()
    }
  }
}
</script>
